const primaryColor = process.env.REACT_APP_PRIMARY_COLOR

export const COLORS = {
    blue: "#2296f3",  
    lightBlue: "#A6D5FA",  
    green: "#8fce00",  
    lightGreen: "#C7E67F",
    primaryColor
}